// src/components/EstagioOpcionalModal.js
import React, { useState, useEffect } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export const EstagioOpcionalModal = ({ show, onClose, handleConfirmar, processing, error }) => {
  const [formData, setFormData] = useState({
    local_nome: '',
    data: '',
    turno: 'dia',
    motivo: ''
  });

  // Limpa o formulário quando o modal é aberto
  useEffect(() => {
    if (show) {
      setFormData({
        local_nome: '',
        data: '',
        turno: 'dia',
        motivo: ''
      });
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleConfirmar(formData);
  };

  return (
    <Modal show={show} onClose={onClose} title="Cadastrar Estágio Opcional" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-gray-700">
          Preencha os detalhes do estágio que você realizou ou irá realizar fora das opções listadas.
          Este registro passará por análise do Escalante/SOE.
        </p>

        <div>
          <label className="block text-sm font-medium text-gray-700">Nome do Local</label>
          <input
            name="local_nome"
            value={formData.local_nome}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="Ex: 4º Batalhão de Choque (GATE)"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Data do Estágio</label>
            <input
              name="data"
              type="date"
              value={formData.data}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Turno</label>
            <select
              name="turno"
              value={formData.turno}
              onChange={handleChange}
              required
              className="w-full border p-2 rounded"
            >
              <option value="dia">Dia</option>
              <option value="noite">Noite</option>
            </select>
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700">Justificativa / Descrição</label>
          <textarea
            name="motivo"
            rows="3"
            value={formData.motivo}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="Descreva brevemente o estágio e o motivo (ex: Visita monitorada, Estágio de Férias, etc.)"
          ></textarea>
        </div>

        {error && <p className="text-red-600 text-sm">{error}</p>}

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button type="button" onClick={onClose} variant="secondary" disabled={processing}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={processing}>
            {processing ? "Salvando..." : "Confirmar Estágio Opcional"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};